import { put } from "redux-saga/effects";
import { fingerPrintRegister } from "../../Services";

export function* RegisterFingerPrint(action) {
  const payload = action.payload;
  try {
    const res = yield fingerPrintRegister(payload);

    yield put({ type: "REQ_REGISTER_FINGERPRINT_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_REGISTER_FINGERPRINT_FAILED", errData: e });
  }
}
